import { ArrowLeft } from 'lucide-react';
import CivicBeatLogo from './CivicBeatLogo';
import { ReactNode } from 'react';

export type HeaderMode = 'logo' | 'title' | 'none';

interface HeaderProps {
  mode: HeaderMode;
  title?: string;
  subtitle?: string;
  showBackButton?: boolean;
  backButtonLabel?: string;
  onBackClick?: () => void;
  rightContent?: ReactNode;
  className?: string;
}

export default function Header({
  mode,
  title,
  subtitle,
  showBackButton = false,
  backButtonLabel,
  onBackClick,
  rightContent,
  className = '',
}: HeaderProps) {
  if (mode === 'none') {
    return null;
  }

  return (
    <div className={`sticky top-0 z-50 bg-[#111111] border-b border-[#282828] px-6 py-4 ${className}`}>
      {mode === 'logo' && (
        <div className="flex flex-col justify-center">
          <CivicBeatLogo />
          {subtitle && (
            <p className="text-[12px] text-[#A0A0A0] mt-1">{subtitle}</p>
          )}
        </div>
      )}

      {mode === 'title' && (
        <div className="flex items-center gap-4 w-full">
          {showBackButton && onBackClick && (
            <button
              onClick={onBackClick}
              className="flex-shrink-0 flex items-center gap-2 text-[#F5F5F5] hover:text-[#40E0D0] transition-colors"
            >
              <ArrowLeft className="w-6 h-6" />
              {backButtonLabel && (
                <span className="text-[16px] font-medium">{backButtonLabel}</span>
              )}
            </button>
          )}
          <div className="flex-1">
            <h1 className="text-[20px] font-semibold text-[#F5F5F5]" style={{ letterSpacing: '-0.005em' }}>
              {title}
            </h1>
            {subtitle && (
              <p className="text-[12px] text-[#A0A0A0] mt-0.5">{subtitle}</p>
            )}
          </div>
          {rightContent && (
            <div className="flex-shrink-0">
              {rightContent}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
